<div class="relative">
  <!-- Settings icon trigger -->
  <button
    type="button"
    class="w-9 h-9 flex items-center justify-center rounded-full bg-white/[0.18] dark:bg-white/[0.08] backdrop-blur-sm border border-white/40 dark:border-white/[0.12] transition-all cursor-pointer focus:outline-none shadow-sm active:scale-95"
    [class]="color() === 'primary' 
      ? 'text-slate-500 hover:text-slate-700' 
      : 'text-white/80 hover:text-white dark:text-slate-400 dark:hover:text-slate-200'"
    (click)="toggleMenu($event)"
    aria-label="Settings"
  >
    <span class="material-symbols-outlined" style="font-size: 18px"
      >settings</span
    >
  </button>

  @if (isOpen()) {
  <!-- Backdrop -->
  <div
    class="fixed inset-0"
    style="z-index: 40"
    role="button"
    tabindex="-1"
    (click)="closeMenu()"
    (keydown.escape)="closeMenu()"
  ></div>

  <!-- Panel -->
  <div
    class="absolute right-0 top-full mt-2 bg-white/95 dark:bg-slate-900/95 backdrop-blur-xl border border-white/50 dark:border-white/10 rounded-2xl shadow-[0_8px_32px_rgba(0,0,0,0.12),0_1px_0_rgba(255,255,255,0.8)] overflow-hidden"
    style="z-index: 50; min-width: 220px"
  >
    <!-- Theme toggle -->
    <div class="px-4 py-3 flex items-center justify-between">
      <div class="flex items-center gap-2.5">
        <span class="material-symbols-outlined text-slate-400 text-[18px]">
          {{ isDark() ? 'dark_mode' : 'light_mode' }}
        </span>
        <span class="text-sm text-[#1E293B] dark:text-slate-300">
          {{ 'USER_MENU.THEME' | translate }}
        </span>
      </div>
      <button
        type="button"
        class="relative w-10 h-[22px] rounded-full transition-colors duration-200 cursor-pointer focus:outline-none flex-shrink-0"
        [class.bg-primary]="isDark()"
        [class.bg-black/10]="!isDark()"
        (click)="toggleTheme()"
      >
        <span
          class="absolute top-[3px] left-[3px] w-4 h-4 bg-white rounded-full shadow-sm transition-transform duration-200"
          [class.translate-x-[18px]]="isDark()"
        ></span>
      </button>
    </div>

    <!-- Language -->
    <div class="px-4 py-3 border-t border-white/30 dark:border-white/10">
      <div class="flex items-center gap-2 mb-2.5">
        <span class="material-symbols-outlined text-slate-400 text-[18px]"
          >language</span
        >
        <span
          class="text-[11px] font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wide"
        >
          {{ 'USER_MENU.LANGUAGE' | translate }}
        </span>
      </div>
      <div class="flex gap-1.5">
        @for (lang of langs; track lang) {
        <button
          type="button"
          class="flex-1 py-1.5 text-xs rounded-lg font-bold uppercase tracking-wide transition-colors cursor-pointer"
          [class.bg-primary]="currentLanguage() === lang"
          [class.text-white]="currentLanguage() === lang"
          [class.bg-white/40]="currentLanguage() !== lang"
          [class.text-slate-500]="currentLanguage() !== lang"
          [class.hover:bg-white/60]="currentLanguage() !== lang"
          (click)="setLanguage(lang)"
        >
          {{ lang }}
        </button>
        }
      </div>
    </div>
  </div>
  }
</div>
